import { z } from "zod";
//#region src/bootstrap.schemas.ts
/**
* Zod schemas for the bootstrap-user endpoint (CP → DP).
* Single source of truth: types in `bootstrap.ts` are `z.infer`'d from
* these schemas so the wire format and TS surface cannot drift.
*/
const BootstrapUserRequestSchema = z.object({
	organizationSlug: z.string().min(1),
	organizationName: z.string().min(1),
	allowedDomains: z.array(z.string().min(1)).optional(),
	adminEmail: z.string().min(1),
	adminDisplayName: z.string().min(1).optional(),
	adminPassword: z.string().min(1).optional(),
	settings: z.record(z.string(), z.unknown()).optional(),
	branding: z.object({
		logoUrl: z.string().min(1).optional(),
		primaryColor: z.string().min(1).optional()
	}).strict().optional()
}).strict();
const BootstrapUserResponseSchema = z.object({
	orgId: z.string().min(1),
	userId: z.string().min(1),
	loginUrl: z.string().min(1),
	temporaryPassword: z.string().min(1).optional()
}).strict();
//#endregion
export { BootstrapUserRequestSchema, BootstrapUserResponseSchema };

//# sourceMappingURL=bootstrap.schemas.js.map